type Listener = (message: string) => void;

const listeners = new Set<Listener>();

/** Tell the admin shell a setting was stored. No-op when the toast host is not mounted. */
export function notifySaved(message = "Saved."): void {
  for (const listener of listeners) listener(message);
}

export function subscribeSaved(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
